<script>
    import { fly } from "svelte/transition";
    import { Tag } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Tag>123</Tag>
    </div>
    <h4 class="example-title">线框标签</h4>
    <div class="example-body">
        <Tag color="primary" fill="outline">Primary</Tag>
        <Tag color="#87d068" fill="outline">#87d068</Tag>
        <Tag color="#ff6430" fill="outline">#ff6430</Tag>
    </div>
    <h4 class="example-title">语义标签</h4>
    <div class="example-body">
        <Tag color="default">Default</Tag>
        <Tag color="primary">测试</Tag>
        <Tag color="success">Success</Tag>
        <Tag color="warning">Warning</Tag>
        <Tag color="danger">Danger</Tag>
    </div>
    <h4 class="example-title">圆角标签</h4>
    <div class="example-body">
        <Tag color="primary" round>测试</Tag>
    </div>

    <h4 class="example-title">自定义颜色</h4>
    <div class="example-body">
        <Tag color="#2db7f5">#2db7f5</Tag>
        <Tag color="#87d068">#87d068</Tag>
        <Tag color="#108ee9">#108ee9</Tag>
    </div>
    <h4 class="example-title">通过 CSS 变量个性化</h4>
    <div class="example-body">
        <Tag color="primary" fill="outline" --border-radius="6px">Primary</Tag>
        <Tag color="success" fill="outline" --background-color="#c8f7c5">
            Success
        </Tag>
        <Tag color="warning" --text-color="var(--sui-color-text)">Warning</Tag>
        <Tag
            color="danger"
            fill="outline"
            --border-color="var(--sui-color-weak)"
        >
            Danger
        </Tag>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
